import React from 'react';
import CreatableSelect from 'react-select/creatable';
import './i18n';
import { t } from 'i18next';

const numberOptions = (min, max) => {
  const options = [];
  for (let i = min; i <= max; i++) {
    options.push({ value: i, label: String(i) });
  }
  return options;
};

const baseSelectStyles = {
  control: (base) => ({
    ...base,
    minWidth: '120px',
    minHeight: '32px',
  }),
};

const CriteriaRoomsPeople = ({ className, value, onChange }) => {
  const { adults = 2, children = 1 } = value || {};

  const adultsOptions = numberOptions(1, 10);
  const childrenOptions = numberOptions(0, 10);

  const adultSelectValue = adultsOptions.find(opt => opt.value === adults) || null;
  const childSelectValue = childrenOptions.find(opt => opt.value === children) || null;

  const handleAdultsChange = (selected) => {
    const newAdults = selected ? selected.value : 1;
    onChange({ adults: newAdults, children });
  };

  const handleChildrenChange = (selected) => {
    const newChildren = selected ? selected.value : 0;
    onChange({ adults, children: newChildren });
  };

  return (
    <div className={`criteria-rooms-people ${className || ''}`}>
      <div className="occupancy-row">
        <div className="occupancy-field">
          <label>{t('Adults')}:</label>
          <CreatableSelect
            options={adultsOptions}
            value={adultSelectValue}
            onChange={handleAdultsChange}
            styles={baseSelectStyles}
            isClearable={false}
          />
        </div>
        <div className="occupancy-field">
          <label>{t('Children')}:</label>
          <CreatableSelect
            options={childrenOptions}
            value={childSelectValue}
            onChange={handleChildrenChange}
            styles={baseSelectStyles}
            isClearable={false}
          />
        </div>
      </div>
    </div>
  );
};

export default CriteriaRoomsPeople;
